<template>
    <b-modal size="lg" scrollable v-model="modalShow"
             title="СЎРОВНОМА"
             :no-close-on-esc="true"
             :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label class="font-italic">Бахоланаётган объект литерлари сони</label>
                        <input type="number" min="1"
                               v-model="surveyData.buildingNumber"
                               placeholder="сони" class="form-control"
                        >
                    </div>
                    <div class="form-group">
                        <label class="font-italic">майдони кв.м</label>
                        <input type="number" min="1"  v-model="surveyData.area"
                               placeholder="майдони кв.м"
                               class="form-control"
                        >
                    </div>
                    <template v-for="(field) in cadastreBuildingFields">
                        <div class="form-group" :key="field.code">
                            <template v-if="field && field.code === 'electrical_devices' && field.type === 'MULTISELECT'" >
                                <label class="font-italic">Коммуникация билан таъминланганлиги  <span class="text-danger">*</span></label>
                                <treeselect :multiple="true" v-model="field.selected"
                                            class="form-control"
                                            :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                            @input="onFieldValueChange(field)"
                                >
                                </treeselect>
                            </template>
                            <template v-else-if="field && field.code === 'wall' && field.type === 'LISTBOX'">
                                <label class="font-italic">Бахоланаётган объект констриктив ечими (девор матариали) <span class="text-danger">*</span></label>
                                <select class="form-control" v-model="field.value"
                                        @change="onFieldValueChange(field)"
                                >
                                    <option :value="option.id" v-for="option in cadastreBuildingFieldReferences[field.reference.code]" :key="option.id">{{option.name}}</option>
                                </select>
                            </template>
                            <template v-else-if="field && field.code === 'demand_for_real_estate' && field.type === 'MULTISELECT'">
                                <label class="font-italic">{{field.name}} <span class="text-danger">*</span></label>
                                <treeselect v-model="field.selected" :multiple="true"
                                            class="form-control"
                                            :options="multiSelectOptions(cadastreBuildingFieldReferences[field.reference.code])"
                                            @input="onFieldValueChange(field)"
                                >
                                </treeselect>
                            </template>
                            <template v-else-if="field && field.code === 'real_estate_service_type' && field.type === 'MULTISELECT'">
                                <label class="font-italic">{{field.name}} <span class="text-danger">*</span></label>
                                <template v-for="(item) in surveyData.data.values[field.code]">
                                    <div class="input-group input-group-sm mb-2" :key="item.code">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text font-weight-bold">{{getReferenceById(field.reference.code, item.id).name}}</span>
                                        </div>
                                        <input type="number" min="0"
                                               class="form-control col-sm-3"
                                               v-model="item.value" placeholder="сони"
                                        >
                                    </div>
                                </template>
                            </template>
                        </div>
                    </template>
                    <div class="form-group">
                        <label class="font-italic">Изоҳ</label>
                        <textarea class="form-control" rows="3" v-model="surveyData.comment"></textarea>
                    </div>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text font-italic">Тел рақами:</span>
                        </div>
                        <the-mask type="tel" :masked="true" class="form-control col-sm-4"
                                  v-model="surveyData.phone"
                                  mask="+(998) ##-###-####" placeholder="+998 (XX) XXX XXXX"
                        />
                    </div>
                    <div class="form-group pull-right">
                        <b-form-checkbox
                                id="hasConfirmed"
                                v-model="surveyData.hasConfirmed"
                                name="hasConfirmed"
                        >
                            <span class="font-italic font-weight-bold">Ушбу тузилган маълумотлар тўғрилигини тасдиклайман.</span>
                        </b-form-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3">
            <button class="all-btn delete-btn float-right ml-2" @click="modalShow=!modalShow">
                {{$t("action.cancel")}}
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import Treeselect from '@riophae/vue-treeselect';
    import { BFormCheckbox } from 'bootstrap-vue'

    export default {
        name: "NewRealEstateSurveyModal",
        components: {
            'b-modal': bModal,
            Treeselect,
            'b-form-checkbox': BFormCheckbox
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                modalShow: false,
                surveyData: {},
                cadastreBuildingFields: [],
                cadastreBuildingFieldReferences: {},
                formDefault: {
                    fields: ["electrical_devices", "wall", "demand_for_real_estate", "real_estate_service_type"]
                }
            }
        },
        methods: {
            init(data) {
                const vm = this;
                this.$http.get('/cadastre/building/init')
                    .then(res => {
                        vm.initResponse(res)
                        vm.initData(data)
                        vm.modalShow = true
                    }, err => {
                        console.log(err)
                    })
            },
            initResponse(res) {
                const initFieldData = res.data;

                this.cadastreBuildingFields = [];
                this.formDefault.fields.forEach((field) => {
                    const leftField = initFieldData.fields.filter((f) => f.code === field);
                    this.cadastreBuildingFields.push(leftField[0])
                });
                this.cadastreBuildingFieldReferences = initFieldData.references;
            },
            initData(data) {
                let formData = {}
                if (data.surveyData) {
                    formData = data.surveyData
                }

                const vm = this;
                if (formData.data && formData.data.values) {
                    vm.cadastreBuildingFields.forEach((field) => {
                        if (field.code && !field.system && formData.data.values.hasOwnProperty(field.code)) {
                            const fieldValue = formData.data.values[field.code];
                            if (fieldValue) {
                                if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                                    if (fieldValue.id && fieldValue.id > 0) {
                                        field.value = fieldValue.id;
                                        field.selected = vm.getReferenceById(field.reference.code, fieldValue.id);
                                    }
                                } else if (field.type === 'MULTISELECT') {
                                    if (fieldValue) {
                                        field.selected = [];
                                        if (fieldValue.length > 0) {
                                            fieldValue.forEach((ref) => {
                                                field.selected.push(ref.id);
                                            });
                                        } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                                            field.selected.push(fieldValue.id);
                                        }
                                        field.value = field.selected;
                                    }
                                } else {
                                    field.value = fieldValue;
                                }
                            }
                        }
                    });
                }

                vm.surveyData = formData;
            },
            multiSelectOptions(options) {
                const items = [];
                if (options && options.length > 0) {
                    options.forEach((option) => {
                        items.push({
                            id: option.id,
                            label: option.name
                        });
                    });
                }
                return items;
            },
            getReferenceById(code, id) {
                if (this.cadastreBuildingFieldReferences.hasOwnProperty(code)) {
                    const fieldReferences = this.cadastreBuildingFieldReferences[code];
                    const references = fieldReferences.filter((ref) => {
                        return ref.id === id
                    });
                    return references.length > 0 ? references[0] : null;
                } else {
                    return null;
                }
            }
        },
        created() {
            this.$eventBus.$on('showBuildingSurveyModal', (realEstate) => {
                if (realEstate && realEstate.surveyData) {
                    this.surveyData = realEstate.surveyData
                    this.modalShow = true
                    this.init(realEstate)
                }
            })
        }
    }
</script>

<style scoped>

</style>